export enum AttributionModelTypes {
  FirstClick = 'FirstClickAttributionModel',
  LastClick = 'LastClickAttributionModel',
  Linear = 'LinearAttributionModel',
  PositionBased = 'PositionalAttributionModel',
  TimeDecay = 'TimeDecayAttributionModel',
  DataDriven = 'DataDrivenAttributionModel',
  Impressions = 'HybridImpressionsAttributionModel'
}
